import React, { lazy, Suspense } from 'react';
import ScrollNext from '../ScrollNext';

const LazyNeonText = lazy(() =>
    new Promise((resolve) => {
        setTimeout(() => {
            import('../NeonText').then(resolve);
        }, 4000);
    })
);

const MainSection = () => {
    return (
        <section
            id="home"
            className="relative flex flex-col items-center justify-center h-screen bg-black text-white"
            style={{
                backgroundColor: '#100D0E',
            }}
        >
            <div className="relative z-20 text-center">
                <h1 className="text-6xl md:text-8xl font-bold">Dmytro Kozin</h1>
                <p className="mt-4 text-lg md:text-2xl tracking-wide">
                    SOFTWARE ENGINEER
                </p>
                <div className="mt-2">
                    <Suspense fallback={<div>open to work</div>}>
                        <a href="mailto:dimakoua@gmail.com"><LazyNeonText text="open to work" /></a>
                    </Suspense>
                </div>
            </div>

            <div className="absolute inset-0 z-1">
                <div
                    className="absolute inset-0 bg-gradient-to-b from-transparent to-[#100D0E]"
                    style={{
                        backgroundImage: `url('/fon.webp')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                    }}
                />
            </div>

            <ScrollNext to="expertise" />
        </section>
    );
};

export default MainSection;
